import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async';
import FotterMain from '../BaseComponents/FotterMain';
import Header from '../BaseComponents/Header'
import 'react-lazy-load-image-component/src/effects/blur.css';
import { baseURL, siteMap } from '../../networkCalls';
import { Link } from 'react-router-dom';
const Sitemap = () => {
    const toTop = () => {
        window.scrollTo(0, 0);
    }

    const [loading, setLoading] = useState(false);
    const [resultData, setResultData] = useState([]);
    const pullSitemapApi = () => {
        var data = new FormData();
        setLoading(true);
        siteMap(data).then((res) => {
            setLoading(false);
            //console.log(res.data);
            switch (res.data.status) {
                case 1:
                    setResultData(res?.data?.siteMap)
                    //setErrMessage('');
                    return true;
                case 0:
                    //setErrMessage(res.data.msz);
                    break;
                default:
                    return;
            }
        })
    }

    useEffect(() => {
        pullSitemapApi();
        toTop();
    }, []);



    return (
        <>
            <Helmet>
                <title>Sitemap</title>
                <meta name="description" content="FAQs" />
            </Helmet>
            <Header />
            <div className='innerpagebg pt-5 pb-5'>
                <div className='container mb-4'>
                    <div className='row'>
                        <div className='col-12  m-auto'>
                            <div className="align-items-center text-center">
                                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                    <span className='txtred'>SITE<span className='txtdgray'>MAP</span></span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='row mb-4'>
                        <div className='col-lg-11 col-mg-12 col-sm-12 col-12 text-start m-auto card pt-4'>
                            {resultData && resultData?.product?.map((itemin, i) => (
                                <div key={i} className="row mb-3">
                                    <div className='mb-1'><a href={itemin?.url} className='fw-bold txtred text-uppercase f16'>{itemin?.name}</a></div>
                                    {itemin && itemin?.subCategory?.map((itemin1, i) => (
                                        <div key={i} className="col-12 col-lg-4">
                                            <div className='txtdgray fw-bold text-uppercase'>{itemin1?.name}</div>
                                            <div>
                                                {itemin1 && itemin1?.products?.map((itemin2, i) => (
                                                    <div key={i} className="">
                                                        <div><a href={itemin?.url} className='text-black'>{itemin2?.name}</a></div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                            <hr />
                            {resultData && resultData?.investors?.map((itemin, i) => (
                                <div key={i} className="row mb-3">
                                    {itemin?.SubCategoryList?.length > 0 ? <>
                                        <div className='mb-1'><span className='fw-bold txtred text-uppercase f16'>{itemin?.name}</span></div>
                                        {itemin && itemin?.SubCategoryList?.map((itemin1, i) => (
                                        <div key={i} className="col-12 col-lg-4">
                                            <div className='txtdgray fw-bold'><a href={itemin1?.link} className='text-black'>{itemin1?.name}</a></div>
                                            {/* <div>
                                                {itemin1 && itemin1?.documents?.map((itemin2, i) => (
                                                    <div key={i} className="">
                                                        <div><a href={itemin?.link} className='text-black'>{itemin2?.name}</a></div>
                                                    </div>
                                                ))}
                                            </div> */}
                                        </div>
                                    ))}

                                    </>:<>
                                        <div className='mb-1'><a href={itemin?.link} className='fw-bold txtred text-uppercase f16'>{itemin?.name}</a></div>
                                    </>}
                                </div>
                            ))}

 
<hr />
<div className='row mb-3'>
    <div className="col-12 col-lg-4 mb-2">
        <Link to="https://www.hondappsv.com/IND" className='text-black f16'>Hondappsv</Link>
    </div>
    <div className="col-12 col-lg-4 mb-2">
        <Link to="/extended-warranty" className='text-black f16'>Extended Warranty</Link>
    </div>
    <div className="col-12 col-lg-4 mb-2">
        <Link to="/honda-genuine-oil" className='text-black f16'>Honda Genuine Oil</Link>
    </div>
    <div className="col-12 col-lg-4 mb-2">
        <Link to="/service-network" className='text-black f16'>Service Network</Link>
    </div>
    <div className="col-12 col-lg-4 mb-2">
        <Link to="/calculator" className='text-black f16'>Calculator</Link>
    </div>

</div>
                            <hr />
                            <div className='row mb-3'>
                                <div className="col-12 col-lg-4 mb-2">
                                    <Link to="/about-us" className='text-black f16'>About Us</Link>
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                    <Link to="/why-buy-a-honda" className='text-black  f16'>Why Buy A Honda</Link>
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                    {/* <Link to="/careers" className='text-black  f16'>Careers</Link> */}
                                    <a className="text-black  f16" href="https://careers.hondaasiaoceania.com/go/HIPP-Jobs/665444/" target='_blank'>Careers</a>
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                    <Link to="/exports" className='text-black  f16'>Exports</Link>
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                    <Link to="/events" className='text-black f16'>Events</Link>
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                    <Link to="/press-release" className='text-black f16'>Press Release</Link>
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                    <Link to="/online-payment" className='text-black f16'>Online Payment</Link>
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                    <Link to="/privacy-policy" className='text-black f16'>Privacy Policy</Link>    
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                     <Link to="/return-refund-policy" className='text-black f16'>Return & Refund Policy</Link>  
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                <Link to="/terms-of-use" className='text-black f16'>Terms and Conditions</Link>
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                <Link to="/faqs" className='text-black f16'>FAQs</Link>
                                </div>
                                <div className="col-12 col-lg-4 mb-2">
                                <Link to="/contact-us" className='text-black f16'>Contact Us</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FotterMain />
        </>
    )
}

export default Sitemap